import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import UserStatsWidget from './UserStatsWidget';
import UserStatisticsGraph from './UserStatisticsGraph';
import MyCurrencies from './MyCurrencies';
// import GreetingCard from './GreetingCard';
import UserDistributionChart from './UserDistributionChart';
import Activities from './Activities';
import Transactions from './Transactions';

const UserCheckIn = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='User Check-In Management' parent='Dashboard' title='User Check-In' />
      <Container fluid={true}>
        <Row className='g-3'>
          {/* Top Row - Stats Widgets */}
          <Col xl='12'>
            <UserStatsWidget />
          </Col>

          {/* Main Content Area */}
          <Col xxl='8' xl='7' lg='12'>
            <Row className='g-3'>
              {/* Statistics Graph */}
              <Col xl='12'>
                <UserStatisticsGraph />
              </Col>
              
              {/* Main Data Table */}
              <Col xl='12'>
                <MyCurrencies />
              </Col>
            </Row>
          </Col>

          {/* Right Sidebar */}
          <Col xxl='4' xl='5' lg='12'>
            <Row className='g-3'>
              {/* Greeting Card - Hidden */}
              {/* <Col xl='12' md='6'>
                <GreetingCard />
              </Col> */}

              {/* User Distribution Chart */}
              <Col xl='12' md='6'>
                <UserDistributionChart />
              </Col>

              {/* Activities */}
              <Col xl='12' md='6'>
                <Activities />
              </Col>

              {/* Recent Transactions */}
              <Col xl='12' md='6'>
                <Transactions />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default UserCheckIn;
